import { Component, inject, OnInit } from '@angular/core';
import {
  Router,
  RouterLink,
  RouterLinkActive,
  RouterOutlet,
  NavigationEnd
} from '@angular/router';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable, shareReplay } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { AsyncPipe, NgOptimizedImage, TitleCasePipe } from '@angular/common';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { ClimateToggleComponent } from '../../../theme/climate-toggle.component';
import { PalettePickerComponent } from '../../../theme/palette-picker.component';
import { MenuItem } from '../../authentication/models/auth-models';
import { AuthService } from '../../authentication/services/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { DialogSingComponent } from '../../pages/dashboard/dialog-sing/dialog-sing.component';
@Component({
  selector: 'nt-layout',
  standalone: true,
  imports: [
    RouterOutlet,
    MatToolbarModule,
    MatButtonModule,
    MatSidenavModule,
    MatListModule,
    MatIconModule,
    AsyncPipe,
    RouterLink,
    RouterLinkActive,
    RouterOutlet,
    NgOptimizedImage,
    ClimateToggleComponent,
    PalettePickerComponent,
    TitleCasePipe,
    MatMenu,
    MatMenuItem,
    MatMenuTrigger,
    MatDividerModule,
  ],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss',
})
export class LayoutComponent implements OnInit {
  private readonly _breakpointObserver = inject(BreakpointObserver);
  private readonly _router: Router = inject(Router);
  private readonly _authService = inject(AuthService);
  private dialog = inject(MatDialog);
  username: string = '';
  routes: Array<MenuItem> = [];
  actualRoute?: { title: string; icon: string };
  isSidebarExpanded = true;
  breadcrumbs$!: Observable<{ label: string; url: string }[]>; // Inicializada en ngOnInit

  ngOnInit() {

    this.username = sessionStorage.getItem('username') ?? '';
    const menu = sessionStorage.getItem('menu');
    if (sessionStorage.getItem('termsAndConditions') == 'NOT_SIGNED') {
      this.dialog.open(DialogSingComponent, { disableClose: true, width: '800px' });
    }
    this.routes = menu ? JSON.parse(menu) : [];

    // Generar breadcrumbs basados en URL
    this.breadcrumbs$ = this._router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => {
        const url = this._router.url.split('?')[0];
        const segments = url.split('/').filter(s => s);
        let currentUrl = '';
        return segments.map(segment => {
          currentUrl += `/${segment}`;
          return { label: segment.replace(/-/g, ' '), url: currentUrl };
        });
      })
    );
  }

  isHandset$: Observable<boolean> = this._breakpointObserver
    .observe(Breakpoints.Handset)
    .pipe(
      map((result) => result.matches),
      shareReplay()
    );

  logout() {
    this._authService.logout();
    this._router.navigateByUrl('/login');
  }

  toggleSidebar() {
    this.isSidebarExpanded = !this.isSidebarExpanded;
  }
}
